import { Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@material-ui/core';
import clsx from 'clsx';
import { FMI_SERVER_DATE_FORMAT } from 'config/constants/dateConstants';
import { commonHelpers } from 'helpers/commonHelper';
import { dateHelper } from 'helpers/dateHelper';
import { messageHelper } from 'helpers/messageHelper';
import { toastHelper } from 'helpers/toastHelper';
import numeral from 'numeral';
import ReactDatePicker from 'react-datepicker';
import { Controller, useForm } from 'react-hook-form';
import { callApiSaveInvoicePayments } from 'redux/saga/mam-non/thu-chi/thu-tien/saveInvoicePayment';

function ThuTienDialog({ thutien, open, closeDialog, onSuccess, congDoanId, classId }) {
    const { register, handleSubmit, errors, control } = useForm();
    console.log('thutien in ThuTienDialog', thutien);

    const defaultValues = {
        id: thutien.id,
        isPaid: thutien.isPaid,
        paidDate: thutien.paidDate ? dateHelper.parseDate(thutien.paidDate) : '',
        note: thutien.note,
    };

    const onSubmit = (data) => {
        const body = {
            isPaid: data.isPaid,
            note: data.note,
            paidDate: dateHelper.formatDate(data.paidDate, FMI_SERVER_DATE_FORMAT),
            truyThuAmount: numeral(thutien.mappingAmount).value(),
        };
        callApiSaveInvoicePayments(congDoanId, classId, thutien.invoice.id, body)
            .then((res) => {
                onSuccess();
                toastHelper.success('Lưu thành công!');
            })
            .catch((err) => {
                messageHelper.showError(err);
            });
    };

    return (
        <Dialog open={open} onClose={closeDialog} aria-labelledby="form-dialog-title" fullWidth maxWidth={'sm'}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle id="form-dialog-title">
                    Chỉnh sửa thu tiền học sinh: {commonHelpers.getStudentFullName({ firstName: thutien?.student?.firstName, lastName: thutien?.student?.lastName })}
                </DialogTitle>
                <DialogContent>
                    <div className="row mb-2">
                        <div className="col-md-6">
                            <label htmlFor="isPaid">
                                Số tiền cần thu: <span className="font-weight-bold">{numeral(thutien.paymentAmount).format('0,0')} VNĐ</span>
                            </label>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="isPaid">
                                Số tiền chuyển: <span className="font-weight-bold">{numeral(thutien.mappingAmount).format('0,0')} VNĐ</span>
                            </label>
                        </div>
                    </div>
                    <Divider />
                    <div className="row mt-4">
                        <div className="col-md-6 form-group">
                            <label htmlFor="isPaid">
                                <input className="mr-2" type="checkbox" defaultChecked={defaultValues.isPaid} name="isPaid" id="isPaid" ref={register} />
                                Đã thu tiền
                            </label>
                            {errors.isPaid && <div className="text-danger pt-2">{errors.isPaid.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <label htmlFor="note">Ghi chú</label>
                            <input
                                type="text"
                                className={clsx('form-control', errors.note && 'border-danger')}
                                placeholder="Ghi chú"
                                defaultValue={defaultValues.note}
                                id="note"
                                name="note"
                                ref={register({})}
                            />
                            {errors.note && <div className="text-danger pt-2">{errors.note.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <label htmlFor="paidDate">Ngày thu tiền</label>
                            <Controller
                                control={control}
                                id="paidDate"
                                name="paidDate"
                                defaultValue={defaultValues.paidDate}
                                render={(props) => (
                                    <ReactDatePicker
                                        placeholderText="Chọn ngày"
                                        onChange={(e) => props.onChange(e)}
                                        className="form-control"
                                        value={new Date(defaultValues.paidDate)}
                                        selected={props.value ? new Date(props.value) : new Date()}
                                        dateFormat="dd.MM.yyyy"
                                        locale="vi"
                                        popperProps={{
                                            positionFixed: true,
                                        }}
                                    />
                                )}
                            />
                            {errors.paidDate && <div className="text-danger pt-2">{errors.paidDate.message}</div>}
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <button type="button" className="btn btn-secondary" onClick={closeDialog}>
                        Đóng
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Lưu
                    </button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

export default ThuTienDialog;
